// Adapted from D:/AI/template-site-factory/src/components/seo/Breadcrumb.tsx
import { Link, useLocation } from 'react-router-dom';
import { ui } from '@/data/nav.en';
import { getLang } from '@/lib/lang';

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export function Breadcrumb({ items }: BreadcrumbProps) {
  const { pathname } = useLocation();
  const t = ui[getLang(pathname)];
  const allItems = [{ label: t.breadcrumbHome, path: t.home }, ...items];

  return (
    <div className="shell">
      <nav aria-label={t.breadcrumb} className="crumb">
        <ol>
          {allItems.map((item, index) => (
            <li key={`${item.path ?? item.label}-${index}`} style={{ display: 'inline' }}>
              {index > 0 && <span aria-hidden="true">›</span>}
              {item.path && index < allItems.length - 1 ? (
                <Link to={item.path}>{item.label}</Link>
              ) : (
                <span aria-current={index === allItems.length - 1 ? 'page' : undefined}>{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
}
